import { createBrowserHistory } from 'history';
const originHistory = createBrowserHistory();
function History() {
  this.action = originHistory.action;
  this.location = originHistory.location;
  this.length = originHistory.length;
  this.push = function (path: string, ...rest: any) {
    originHistory.push(path, ...rest);
  };

  this.replace = function (path: string, ...rest: any) {
    originHistory.replace(path, ...rest);
  };

  this.block = function (...rest: any) {
    originHistory.block(...rest);
  };
  this.createHref = function (location: any) {
    originHistory.createHref(location);
  };
  this.go = function (n: number) {
    originHistory.go(n);
  };
  this.goBack = function () {
    originHistory.goBack();
  };
  this.goForward = function () {
    originHistory.goForward();
  };

  this.listen = function (listener: any) {
    originHistory.listen(listener);
  };
  this.sayHi = function () {
    alert('hi');
  };
}
const history = new History();

export { history };
export default originHistory;
